var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCareLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.997,
    height: 20,
    viewBox: "0 0 19.997 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6082",
    "data-name": "Group 6082",
    transform: "translate(-0.098 -0.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78045",
    "data-name": "Path 78045",
    d: "M11.543,12.489a13.715,13.715,0,0,1,.832,1.173,11.173,11.173,0,0,1,1.287-1.287,13.58,13.58,0,0,1-1.174-.833A12.8,12.8,0,0,0,11.543,12.489Zm4.477,1.074a13.44,13.44,0,0,1-1.46-.667,10.286,10.286,0,0,0-1.666,1.666,13.431,13.431,0,0,1,.667,1.46A8.885,8.885,0,0,1,16.02,13.563ZM10.272,9.322a13.428,13.428,0,0,1-.833-1.174A11.286,11.286,0,0,1,8.152,9.436a13.561,13.561,0,0,1,1.173.833,12.621,12.621,0,0,0,.946-.946Zm-2.02-3.53A8.9,8.9,0,0,1,5.793,8.251a13.427,13.427,0,0,1,1.46.667A10.294,10.294,0,0,0,8.919,7.251,13.553,13.553,0,0,1,8.251,5.793Zm11.835,8.651a13.493,13.493,0,0,1-2.842-.473,7.9,7.9,0,0,0-3.275,3.276,13.52,13.52,0,0,1,.474,2.841h.071a6.453,6.453,0,0,1,5.571-5.572ZM7.843,4.568A13.54,13.54,0,0,1,7.37,1.727H7.3A6.455,6.455,0,0,1,1.728,7.3V7.37a13.551,13.551,0,0,1,2.841.473A7.9,7.9,0,0,0,7.844,4.568Z",
    transform: "translate(-0.809 -0.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78046",
    "data-name": "Path 78046",
    d: "M7.945,32.089h-1.4A6.451,6.451,0,0,0,.1,25.646v-1.4a7.852,7.852,0,0,1,7.843,7.843Z",
    transform: "translate(-0.002 -11.992)",
    fill: "#82cece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78047",
    "data-name": "Path 78047",
    d: "M10.323,29.744h-1.4A8.83,8.83,0,0,0,.1,20.923v-1.4a10.233,10.233,0,0,1,10.22,10.221Z",
    transform: "translate(-0.002 -9.647)",
    fill: "#82cece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78048",
    "data-name": "Path 78048",
    d: "M12.694,27.4h-1.4A11.21,11.21,0,0,0,.1,16.2V14.8a12.612,12.612,0,0,1,12.6,12.6Z",
    transform: "translate(0 -7.302)",
    fill: "#82cece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78049",
    "data-name": "Path 78049",
    d: "M32.085,7.945A7.851,7.851,0,0,1,24.243.1h1.4a6.45,6.45,0,0,0,6.443,6.444v1.4Z",
    transform: "translate(-11.99 -0.002)",
    fill: "#fdbe14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78050",
    "data-name": "Path 78050",
    d: "M29.739,10.324A10.233,10.233,0,0,1,19.519.1h1.4a8.83,8.83,0,0,0,8.821,8.822v1.4Z",
    transform: "translate(-9.644 -0.002)",
    fill: "#fdbe14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78051",
    "data-name": "Path 78051",
    d: "M27.4,12.7A12.611,12.611,0,0,1,14.8.1h1.4A11.211,11.211,0,0,0,27.4,11.3Z",
    transform: "translate(-7.3 0)",
    fill: "#fdbe14"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCareLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/care-logo.12fdb5e0.svg";
export { ForwardRef as ReactComponent };